import { render, staticRenderFns } from "./UpdateReception.vue?vue&type=template&id=9791a05c&scoped=true"
import script from "./UpdateReception.vue?vue&type=script&lang=js"
export * from "./UpdateReception.vue?vue&type=script&lang=js"
import style0 from "./UpdateReception.vue?vue&type=style&index=0&id=9791a05c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9791a05c",
  null
  
)

export default component.exports